import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import { useCallback, useMemo, useState } from 'react';
import { css, jsx } from '@emotion/react'; // eslint-disable-line @atlaskit/ui-styling-standard/use-compiled

import { addLink, getAriaKeyshortcuts } from '@atlaskit/editor-common/keymaps';
import { ArrowKeyNavigationType, DropdownMenu, ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import { getOverflowPrimaryToolbarConfig } from './overflow-toolbar-config';
var DROPDOWN_WIDTH = 240;
export function PrimaryToolbarComponent(_ref) {
  var api = _ref.api,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsScrollableElement = _ref.popupsScrollableElement;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var items = useMemo(function () {
    return getOverflowPrimaryToolbarConfig({
      api: api
    });
  }, [api]);
  var content = 'Show more items';
  var onClick = useCallback(function () {
    setIsOpen(!isOpen);
  }, [isOpen]);
  var onMenuItemActivated = useCallback(function (_ref2) {
    var _item$onClick;
    var item = _ref2.item;
    item === null || item === void 0 || (_item$onClick = item.onClick) === null || _item$onClick === void 0 || _item$onClick.call(item);
  }, []);
  return jsx(DropdownMenu, {
    isOpen: isOpen,
    onOpenChange: function onOpenChange(attrs) {
      return setIsOpen(attrs.isOpen);
    },
    items: items,
    arrowKeyNavigationProviderOptions: {
      type: ArrowKeyNavigationType.MENU
    },
    boundariesElement: popupsBoundariesElement,
    mountTo: popupsMountPoint,
    scrollableElement: popupsScrollableElement,
    section: {
      hasSeparator: true
    },
    onItemActivated: onMenuItemActivated,
    fitWidth: DROPDOWN_WIDTH
  }, jsx(ToolbarButton, {
    onClick: onClick,
    "aria-haspopup": "dialog",
    "aria-keyshortcuts": getAriaKeyshortcuts(addLink),
    "aria-label": content,
    title: content
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
    ,
    css: buttonStyles
  }, jsx(ShowMoreHorizontalIcon, {
    label: content
  })));
}
var buttonStyles = css({
  padding: "var(--ds-space-075, 6px)"
});